import { Link } from "react-router-dom";
import { useLang } from "../../contexts/LanguageContext";
import PageHero from "../../components/public/PageHero";
import { Briefcase, GraduationCap, FileText, UserSearch, TrendingUp, Scale, Users, Globe2, ArrowUpRight } from "lucide-react";

export default function Servicios() {
  const { t } = useLang();
  const items = [
    { icon: FileText, key: "info", to: "/servicios/informacion-empresarial" },
    { icon: GraduationCap, key: "training", to: "/servicios/plataforma-formacion" },
    { icon: Briefcase, key: "visa", to: "/servicios/gestion-visados" },
    { icon: UserSearch, key: "jobs", to: "/servicios/bolsa-empleo" },
    { icon: TrendingUp, key: "opportunities", to: "/servicios/oportunidades-negocio" },
    { icon: Scale, key: "arbitration", to: "/servicios" },
    { icon: Users, key: "networking", to: "/servicios" },
    { icon: Globe2, key: "promotion", to: "/servicios" },
  ];

  return (
    <div data-testid="servicios-page">
      <PageHero
        title={t("nav.servicios")}
        subtitle={t("home.servicesBody")}
        image="https://images.unsplash.com/photo-1571645163064-77faa9676a46?auto=format&fit=crop&w=2000&q=80"
      />
      <section className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-gray-200">
          {items.map(({ icon: Icon, key, to }) => (
            <Link
              key={key}
              to={to}
              data-testid={`servicio-${key}`}
              className="bg-white p-10 group hover:bg-[#0F2040] transition-colors duration-500"
            >
              <Icon className="w-9 h-9 text-[#C8102E] group-hover:text-cecit-gold transition-colors mb-5" strokeWidth={1.4} />
              <h3 className="font-serif text-2xl text-[#0F2040] group-hover:text-white transition-colors mb-3">
                {t(`services.${key}`)}
              </h3>
              <p className="text-sm text-gray-600 group-hover:text-white/70 transition-colors mb-5">
                {t(`services.${key}Desc`)}
              </p>
              <span className="inline-flex items-center gap-1.5 text-xs uppercase tracking-widest text-[#0F2040] group-hover:text-cecit-gold transition-colors">
                {t("common.readMore")} <ArrowUpRight className="w-3.5 h-3.5" />
              </span>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
